import { useState } from 'react';
import './App.css';

function App() {
  const [username, setUsername] = useState('');
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const searchUser = async () => {
    if (!username) return;
    setLoading(true);
    setError('');
    try {
      const res = await fetch(`https://api.github.com/users/${username}`);
      if (!res.ok) throw new Error('User not found');
      const data = await res.json();
      setUser(data);
    } catch (err) {
      setError(err.message);
      setUser(null);
    }
    setLoading(false);
  };

  return (
    <div className="app">
      <h1>GitHub Profile Finder</h1>
      <div className="search">
        <input
          value={username}
          onChange={e => setUsername(e.target.value)}
          onKeyDown={e => e.key === 'Enter' && searchUser()}
          placeholder="Enter GitHub username..."
        />
        <button onClick={searchUser}>Search</button>
      </div>
      {loading && <p className="loading">Searching...</p>}
      {error && <p className="error">{error}</p>}
      {user && (
        <div className="card">
          <img src={user.avatar_url} alt={user.login} />
          <h2>{user.name || user.login}</h2>
          <p className="bio">{user.bio}</p>
          <div className="stats">
            <div><strong>{user.public_repos}</strong><span>Repos</span></div>
            <div><strong>{user.followers}</strong><span>Followers</span></div>
            <div><strong>{user.following}</strong><span>Following</span></div>
          </div>
          <a href={user.html_url} target="_blank" rel="noreferrer">View on GitHub →</a>
        </div>
      )}
    </div>
  );
}

export default App;